// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errors-tab {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: var(--wellsky-sand-tint);
  border-radius: 8px;
  min-height: 600px;
}

.errors-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.errors-header h2 {
  margin: 0;
  font-size: 24px;
  color: var(--wellsky-indigo);
}

.errors-header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.last-updated {
  font-size: 12px;
  color: var(--wellsky-indigo);
  opacity: 0.6;
  white-space: nowrap;
}

.refresh-button {
  padding: 8px 16px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.refresh-button:hover:not(:disabled) {
  background: var(--wellsky-ocher);
}

.refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.filter-toggle-button {
  padding: 8px 16px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.filter-toggle-button:hover {
  background: var(--wellsky-ocher);
}

/* Filters Panel */
.filters-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  padding: 20px;
  background: var(--wellsky-white);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  margin-bottom: 20px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-group label {
  font-weight: 600;
  font-size: 14px;
  color: var(--wellsky-indigo);
}

.filter-group input,
.filter-group select {
  padding: 8px 12px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  background-color: var(--wellsky-white);
}

.filter-group input:focus,
.filter-group select:focus {
  outline: none;
  border-color: var(--wellsky-blue);
  box-shadow: 0 0 0 3px rgba(113, 176, 180, 0.25);
}

.clear-filters-button {
  grid-column: 1 / -1;
  padding: 10px 16px;
  background: var(--wellsky-sand);
  color: var(--wellsky-indigo);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.clear-filters-button:hover {
  background: var(--wellsky-ocher);
  color: white;
}

/* Statistics Panel */
.statistics-panel {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
  margin-bottom: 20px;
}

.stat-card {
  background: var(--wellsky-white);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stat-number {
  font-size: 32px;
  font-weight: bold;
  color: var(--wellsky-blue);
  margin-bottom: 10px;
}

.stat-label {
  font-size: 14px;
  color: var(--wellsky-indigo);
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* High/Critical cards get extra emphasis so they read at a glance */
.stat-card-emphasis {
  border-width: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* Filter-aware result count */
.results-summary {
  font-size: 14px;
  color: var(--wellsky-indigo);
  margin-bottom: 4px;
}

.results-summary strong {
  color: var(--wellsky-blue);
}

/* Errors Container */
.errors-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background: var(--wellsky-white);
  border-radius: 8px;
  border: 1px solid var(--color-border);
  padding: 20px;
}

.error-message {
  padding: 15px;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  font-size: 14px;
}

.loading,
.no-errors {
  padding: 40px 20px;
  text-align: center;
  color: #6c757d;
  font-size: 16px;
}

/* Errors Table */
.errors-table-wrapper {
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  max-height: 600px;
}

.errors-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.errors-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  text-align: left;
  padding: 10px 12px;
  background: var(--wellsky-sand);
  color: var(--wellsky-indigo);
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.error-row {
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid var(--color-border);
}

.error-row:hover {
  background: var(--wellsky-sand-tint);
}

.error-row:focus-visible {
  outline: 2px solid #1976d2;
  outline-offset: -2px;
}

/* Non-blocking "updating" indicator shown above the table while a refresh is in
   flight, so filtering never blanks the current results. */
.results-updating {
  padding: 6px 12px;
  font-size: 13px;
  color: #666;
  font-style: italic;
}

.error-row.expanded {
  background: var(--wellsky-sand-tint);
}

.error-row td {
  padding: 10px 12px;
  color: var(--wellsky-indigo);
  vertical-align: top;
}

.errors-table .col-time {
  white-space: nowrap;
}

.errors-table .col-message {
  max-width: 360px;
  line-height: 1.4;
}

.errors-table .col-contact {
  white-space: nowrap;
}

.severity-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  color: white;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
}

.error-category {
  display: inline-block;
  padding: 3px 8px;
  background: rgba(113, 176, 180, 0.2);
  color: var(--wellsky-indigo);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.error-service {
  font-size: 12px;
  color: var(--wellsky-indigo);
}

/* Detail row (expanded) */
.error-detail-row td {
  padding: 0;
  background: var(--wellsky-white);
}

.call-sid-link {
  font-family: 'Monaco', 'Courier New', monospace;
  font-size: 12px;
  color: var(--wellsky-blue);
  text-decoration: none;
}

.call-sid-link:hover {
  color: var(--wellsky-ocher);
  text-decoration: underline;
}

/* Expanded Details */
.error-details {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid var(--color-border);
  background: var(--wellsky-white);
  padding: 15px;
  border-radius: 4px;
}

.detail-section {
  margin-bottom: 15px;
}

.detail-section:last-child {
  margin-bottom: 0;
}

.detail-section h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: var(--wellsky-blue);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-section p {
  margin: 5px 0;
  font-size: 14px;
  color: var(--wellsky-indigo);
  line-height: 1.6;
  word-break: break-word;
}

.detail-section strong {
  color: var(--wellsky-indigo);
  font-weight: 600;
}

.context-json {
  background: var(--wellsky-sand-tint);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 12px;
  font-size: 12px;
  font-family: 'Courier New', monospace;
  overflow-x: auto;
  max-height: 300px;
  color: var(--wellsky-indigo);
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  padding: 15px 0;
  border-top: 1px solid var(--color-border);
  margin-top: 15px;
  flex-wrap: wrap;
}

.pagination button {
  padding: 8px 16px;
  background: var(--wellsky-blue);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.2s;
}

.pagination button:hover:not(:disabled) {
  background: var(--wellsky-ocher);
}

.pagination button:disabled {
  background: var(--wellsky-sand);
  color: var(--wellsky-indigo);
  opacity: 0.6;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: var(--wellsky-indigo);
  opacity: 0.7;
  white-space: nowrap;
}

.page-size-select {
  padding: 6px 12px;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  font-size: 14px;
  background-color: var(--wellsky-white);
  cursor: pointer;
}

.page-size-select:focus {
  outline: none;
  border-color: var(--wellsky-blue);
  box-shadow: 0 0 0 3px rgba(113, 176, 180, 0.25);
}

/* Responsive */
@media (max-width: 768px) {
  .filters-panel {
    grid-template-columns: 1fr;
  }

  .errors-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .errors-header-actions {
    flex-wrap: wrap;
  }

  .pagination {
    flex-direction: column;
    gap: 10px;
  }

  .page-info {
    width: 100%;
    text-align: center;
  }

  .errors-table-wrapper {
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/ErrorsTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;;EAEE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;2DAC2D;AAC3D;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;EAC/C,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".errors-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: var(--wellsky-sand-tint);\n  border-radius: 8px;\n  min-height: 600px;\n}\n\n.errors-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.errors-header h2 {\n  margin: 0;\n  font-size: 24px;\n  color: var(--wellsky-indigo);\n}\n\n.errors-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.last-updated {\n  font-size: 12px;\n  color: var(--wellsky-indigo);\n  opacity: 0.6;\n  white-space: nowrap;\n}\n\n.refresh-button {\n  padding: 8px 16px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.refresh-button:hover:not(:disabled) {\n  background: var(--wellsky-ocher);\n}\n\n.refresh-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.filter-toggle-button {\n  padding: 8px 16px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.filter-toggle-button:hover {\n  background: var(--wellsky-ocher);\n}\n\n/* Filters Panel */\n.filters-panel {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n  padding: 20px;\n  background: var(--wellsky-white);\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  margin-bottom: 20px;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filter-group label {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--wellsky-indigo);\n}\n\n.filter-group input,\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  background-color: var(--wellsky-white);\n}\n\n.filter-group input:focus,\n.filter-group select:focus {\n  outline: none;\n  border-color: var(--wellsky-blue);\n  box-shadow: 0 0 0 3px rgba(113, 176, 180, 0.25);\n}\n\n.clear-filters-button {\n  grid-column: 1 / -1;\n  padding: 10px 16px;\n  background: var(--wellsky-sand);\n  color: var(--wellsky-indigo);\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.clear-filters-button:hover {\n  background: var(--wellsky-ocher);\n  color: white;\n}\n\n/* Statistics Panel */\n.statistics-panel {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.stat-card {\n  background: var(--wellsky-white);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.stat-number {\n  font-size: 32px;\n  font-weight: bold;\n  color: var(--wellsky-blue);\n  margin-bottom: 10px;\n}\n\n.stat-label {\n  font-size: 14px;\n  color: var(--wellsky-indigo);\n  opacity: 0.7;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* High/Critical cards get extra emphasis so they read at a glance */\n.stat-card-emphasis {\n  border-width: 2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n/* Filter-aware result count */\n.results-summary {\n  font-size: 14px;\n  color: var(--wellsky-indigo);\n  margin-bottom: 4px;\n}\n\n.results-summary strong {\n  color: var(--wellsky-blue);\n}\n\n/* Errors Container */\n.errors-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  background: var(--wellsky-white);\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n  padding: 20px;\n}\n\n.error-message {\n  padding: 15px;\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.loading,\n.no-errors {\n  padding: 40px 20px;\n  text-align: center;\n  color: #6c757d;\n  font-size: 16px;\n}\n\n/* Errors Table */\n.errors-table-wrapper {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: auto;\n  max-height: 600px;\n}\n\n.errors-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.errors-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  text-align: left;\n  padding: 10px 12px;\n  background: var(--wellsky-sand);\n  color: var(--wellsky-indigo);\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.error-row {\n  cursor: pointer;\n  transition: background 0.15s;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.error-row:hover {\n  background: var(--wellsky-sand-tint);\n}\n\n.error-row:focus-visible {\n  outline: 2px solid #1976d2;\n  outline-offset: -2px;\n}\n\n/* Non-blocking \"updating\" indicator shown above the table while a refresh is in\n   flight, so filtering never blanks the current results. */\n.results-updating {\n  padding: 6px 12px;\n  font-size: 13px;\n  color: #666;\n  font-style: italic;\n}\n\n.error-row.expanded {\n  background: var(--wellsky-sand-tint);\n}\n\n.error-row td {\n  padding: 10px 12px;\n  color: var(--wellsky-indigo);\n  vertical-align: top;\n}\n\n.errors-table .col-time {\n  white-space: nowrap;\n}\n\n.errors-table .col-message {\n  max-width: 360px;\n  line-height: 1.4;\n}\n\n.errors-table .col-contact {\n  white-space: nowrap;\n}\n\n.severity-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  color: white;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.error-category {\n  display: inline-block;\n  padding: 3px 8px;\n  background: rgba(113, 176, 180, 0.2);\n  color: var(--wellsky-indigo);\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.error-service {\n  font-size: 12px;\n  color: var(--wellsky-indigo);\n}\n\n/* Detail row (expanded) */\n.error-detail-row td {\n  padding: 0;\n  background: var(--wellsky-white);\n}\n\n.call-sid-link {\n  font-family: 'Monaco', 'Courier New', monospace;\n  font-size: 12px;\n  color: var(--wellsky-blue);\n  text-decoration: none;\n}\n\n.call-sid-link:hover {\n  color: var(--wellsky-ocher);\n  text-decoration: underline;\n}\n\n/* Expanded Details */\n.error-details {\n  margin-top: 15px;\n  padding-top: 15px;\n  border-top: 1px solid var(--color-border);\n  background: var(--wellsky-white);\n  padding: 15px;\n  border-radius: 4px;\n}\n\n.detail-section {\n  margin-bottom: 15px;\n}\n\n.detail-section:last-child {\n  margin-bottom: 0;\n}\n\n.detail-section h4 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  color: var(--wellsky-blue);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.detail-section p {\n  margin: 5px 0;\n  font-size: 14px;\n  color: var(--wellsky-indigo);\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n.detail-section strong {\n  color: var(--wellsky-indigo);\n  font-weight: 600;\n}\n\n.context-json {\n  background: var(--wellsky-sand-tint);\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  padding: 12px;\n  font-size: 12px;\n  font-family: 'Courier New', monospace;\n  overflow-x: auto;\n  max-height: 300px;\n  color: var(--wellsky-indigo);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  margin: 0;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 0;\n  border-top: 1px solid var(--color-border);\n  margin-top: 15px;\n  flex-wrap: wrap;\n}\n\n.pagination button {\n  padding: 8px 16px;\n  background: var(--wellsky-blue);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.2s;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: var(--wellsky-ocher);\n}\n\n.pagination button:disabled {\n  background: var(--wellsky-sand);\n  color: var(--wellsky-indigo);\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.page-info {\n  font-size: 14px;\n  color: var(--wellsky-indigo);\n  opacity: 0.7;\n  white-space: nowrap;\n}\n\n.page-size-select {\n  padding: 6px 12px;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: var(--wellsky-white);\n  cursor: pointer;\n}\n\n.page-size-select:focus {\n  outline: none;\n  border-color: var(--wellsky-blue);\n  box-shadow: 0 0 0 3px rgba(113, 176, 180, 0.25);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .filters-panel {\n    grid-template-columns: 1fr;\n  }\n\n  .errors-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .errors-header-actions {\n    flex-wrap: wrap;\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .page-info {\n    width: 100%;\n    text-align: center;\n  }\n\n  .errors-table-wrapper {\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
